/**
 * Parses a date string and returns a date-only display string via `Date`. Central place to adjust locale or style for
 * glass widget stat dates.
 *
 * @param value
 * @param fallback
 */
const formatDateOnly = (value, fallback = '—') => {
  if (value == null || value === '') return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

/**
 * Prefer a non-empty trimmed API display string when present; otherwise format `iso` with formatDateOnly.
 *
 * @param display
 * @param iso
 */
const milestoneDateDisplay = (display, iso) => {
  const t = display?.trim();
  if (t) return t;
  return formatDateOnly(iso);
};

/**
 * True when a milestone-style field has a real date to show (non-empty display or parseable ISO).
 *
 * @param display
 * @param iso
 */
const milestoneHasValue = (display, iso) => {
  if (display?.trim()) return true;
  if (iso == null || iso === '') return false;
  return !Number.isNaN(new Date(iso).getTime());
};

export default {
  formatDateOnly,
  milestoneDateDisplay,
  milestoneHasValue,
};
